import React, { Dispatch, FC, SetStateAction } from "react";
import { WidgetBorderTheme } from "@xapp/intelligent-search-widget";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { WidgetBorderRadiusPicker } from "../WidgetThemeBuilder/BorderRadiusPicker";
import { WidgetBorderWidthPicker } from "../WidgetThemeBuilder/BorderWidthPicker";
import { ThemeBuilderSection } from "../WidgetThemeBuilder/ThemeBuilderSection";
import { WidgetColorPicker } from "../WidgetThemeBuilder/WidgetColorPicker";
import { SearchWidgetBorderStylePicker } from "./BorderStylePicker";

export interface WidgetBorderThemeBuilderProps {
    readonly theme: WidgetBorderTheme | undefined;
    readonly noRadius?: boolean;
    readonly defaultTheme: WidgetBorderTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<WidgetBorderTheme>>;
}

const EMPTY_THEME: WidgetBorderTheme = {};

const SearchWidgetBorderThemeBuilderInner: FC<WidgetBorderThemeBuilderProps> = props => {
    const theme: WidgetBorderTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: WidgetBorderTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const handleColorChange = useOnChangeChildDispatch("color", onChange);
    const handleWidthChange = useOnChangeChildDispatch("width", onChange);
    const handleRadiusChange = useOnChangeChildDispatch("radius", onChange);
    const handleStyleChange = useOnChangeChildDispatch("style", onChange);

    return (
        <ThemeBuilderSection heading="Border" className="widget-border-builder">
            <WidgetColorPicker key="color" value={theme.color} defaultValue={defaultTheme.color} onChange={handleColorChange} />
            <WidgetBorderWidthPicker key="width" value={theme.width} defaultValue={defaultTheme.width} onChange={handleWidthChange} />
            {!props.noRadius && <WidgetBorderRadiusPicker key="radius" value={theme.radius} defaultValue={defaultTheme.radius} onChange={handleRadiusChange} />}
            <SearchWidgetBorderStylePicker key="style" value={theme.style} defaultValue={defaultTheme.style} onChange={handleStyleChange} />
        </ThemeBuilderSection>
    );
};

export const SearchWidgetBorderThemeBuilder = React.memo(SearchWidgetBorderThemeBuilderInner);
